import { Link } from 'react-router-dom';
import { modules } from '../lib/modules';
import { Icon } from '../components/Icon';

const activity = [
  { icon: 'FileScan', text: '3 documentos prontos para revisão', meta: 'Inspector Doc' },
  { icon: 'Target', text: 'Plano fiscal de 30 dias criado', meta: 'Radar Fiscal' },
  { icon: 'Network', text: '7 ideias activas no laboratório', meta: 'Atlas offline' }
];

export function Dashboard() {
  return (
    <div className="dashboard-stack">
      <section className="hero-panel">
        <div className="hero-copy">
          <span className="status-chip"><span /> Sistema local-first operacional</span>
          <h2>Da evidência à execução, <em>com clareza.</em></h2>
          <p>Um ambiente profissional para estruturar trabalho, rever documentos e concluir cada processo com uma próxima acção verificável.</p>
          <div className="hero-actions">
            <Link className="primary-button" to="/atlas"><Icon name="Network" size={18} /> Abrir laboratório de ideias</Link>
            <Link className="secondary-button" to="/apps/radar-fiscal">Iniciar um processo <Icon name="ChevronRight" size={17} /></Link>
          </div>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <div className="orbit orbit-one" /><div className="orbit orbit-two" />
          <div className="core"><Icon name="Network" size={34} /></div>
          <span className="satellite one"><Icon name="FileScan" /></span>
          <span className="satellite two"><Icon name="CircleGauge" /></span>
          <span className="satellite three"><Icon name="ShieldCheck" /></span>
        </div>
      </section>

      <section className="stats-grid">
        <article><span>12</span><div><strong>Produtos activos</strong><small>1 offline + 10 IA + fiscal</small></div></article>
        <article><span>100%</span><div><strong>Dados locais</strong><small>Controlo no seu dispositivo</small></div></article>
        <article><span>&lt;1s</span><div><strong>Motor local</strong><small>Organização sem internet</small></div></article>
        <article><span>AO</span><div><strong>Contexto angolano</strong><small>Fontes e moeda local</small></div></article>
      </section>

      <div className="section-heading">
        <div><span className="eyebrow">ÁREAS DE TRABALHO</span><h2>Ferramentas operacionais</h2></div>
        <Link to="/fiscalidade">Abrir Fiscalidade AO <Icon name="ChevronRight" size={16} /></Link>
      </div>
      <section className="module-grid">
        {modules.map((item, index) => (
          <Link key={item.id} to={`/apps/${item.id}`} className={`module-card accent-${item.accent}`}>
            <div className="module-top"><span className="module-icon"><Icon name={item.icon} /></span><small>{String(index + 1).padStart(2, '0')}</small></div>
            <span className="module-category">{item.category}</span>
            <h3>{item.name}</h3>
            <p>{item.tagline}</p>
            <div className="module-foot"><span>{item.features[0]}</span><Icon name="ChevronRight" size={18} /></div>
          </Link>
        ))}
      </section>

      <section className="dashboard-bottom">
        <article className="fiscal-callout">
          <div><span className="module-icon"><Icon name="Calculator" /></span><span className="eyebrow">MÓDULO ESPECIALIZADO</span></div>
          <h3>Fiscalidade AO</h3>
          <p>Calculadoras configuráveis, calendário operacional, fontes oficiais e checklists de revisão.</p>
          <Link className="secondary-button" to="/fiscalidade">Explorar módulo <Icon name="ChevronRight" size={16} /></Link>
        </article>
        <article className="activity-panel">
          <div className="section-heading compact"><h3>Pulso operacional</h3><span>Hoje</span></div>
          {activity.map((item) => <div className="activity-row" key={item.text}><span><Icon name={item.icon} /></span><div><strong>{item.text}</strong><small>{item.meta}</small></div></div>)}
        </article>
      </section>
    </div>
  );
}
